import { t } from 'i18next';

interface Props {
  isMinimized: boolean;
  trackerTimer: string;
}

export const getTrackerTitle = ({
  isMinimized,
  trackerTimer,
}: Props): string => {
  if (isMinimized) {
    return trackerTimer;
  }

  return t('labels.timer', { time: trackerTimer });
};
